(function ($) {
	$.fn.shopMenu = function() {

        function clacMaxHeight() {
            maxHeight = window.innerHeight - $('#nm-header').height();
            if (! $('body').hasClass('header-on-scroll')) {
                maxHeight = maxHeight - $('#nm-top-bar').height();
            }

            if ( height > maxHeight ) {
                shop_menu.css('overflow-y', 'scroll');
            } else {
                shop_menu.css('overflow-y', 'hidden');
            }
        }

        var shop_menu = $('#shop_menu');
        var menu_item = $('#menu-item-239');
        var maxHeight = window.innerHeight - $('#nm-header').height();
        if (! $('body').hasClass('header-on-scroll')) {
            maxHeight = maxHeight - $('#nm-top-bar').height();
        }
        var height = shop_menu.find('.shop-menu__container').height();

        if ( height > maxHeight ) {
            shop_menu.css('overflow-y', 'scroll');
        }

        $(window).on('scroll', function(){
            clacMaxHeight();
        });

        $(window).on('resize', function(){
            clacMaxHeight();
        });

        menu_item.on('mouseover', function(){
            $(this).addClass('header-menu__item--open');
            shop_menu.addClass('shop-menu--visible');
            shop_menu.css('max-height', maxHeight);
        });
        var menu_item = $('#menu-item-239');

        menu_item.on('mouseout', function(){
            $(this).removeClass('header-menu__item--open');
            shop_menu.removeClass('shop-menu--visible');
            shop_menu.css('max-height', 0);
        });
		
	};
})(jQuery);